import React, { useEffect, useState } from 'react';
import { FaEnvelope, FaEye, FaEyeSlash, FaGoogle } from 'react-icons/fa';
import { useLocation, useNavigate } from "react-router-dom";
import logoFull from '../../assets/images/mmiilogo.png';
import useNavigateNext from '../../common/components/useNavigateNext';
import { useAuth } from '../AutoContextProvider';

const Login = (props) => {
    const [state, {
        sso,
        getAuthGoogleUrl,
        logout,
        setAuth,
        setAuthToken,
        getCookie,
        getInitialGuestToken,
        getFinalGuestToken,
        setRole,
      }] = useAuth()
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [err, setErr] = useState({})
    const errObj = {}
    const location = useLocation();
    const { googleSignIn } = location?.state? location?.state : false
    const [showPassword, setShowPassword] = useState(false);
    const [searchParams, navigateNext] = useNavigateNext(location)
    const navigate =useNavigate()
    const abort = new AbortController()

    useEffect(()=>{
        if(googleSignIn != undefined || googleSignIn != null || googleSignIn == true){
          errObj.email = 'Invalid Email. Please try again '
          errObj.password = ' '
          errObj.email_password='INVALID'
          navigate(location.pathname, {replace: true});
          setErr({...err, errObj})
        }
      }, [googleSignIn])

    useEffect(()=>{
    const nextParam = searchParams.get('next')
    //clear auth cookies
    logout()
    .then(_=>{
        getAuthGoogleUrl({next: nextParam})
        .then(url=>{
        setAuthToken({external_sources: {url: url.url}})
        })
    })
    return ()=>{
        abort.abort()
    } 
    }, [])


    const tokenParam = searchParams.get('token')
    const refreshParam = searchParams.get('refresh')
    
    const performSso = async () => {

    if (tokenParam) {
        const ssoData = await sso(tokenParam, refreshParam);
        if (ssoData) {
        // navigate(`/Home`)
        } else {
        location.googleSignIn = true;
        // navigateNext('/');
        }
    } else {
        const token = getCookie('tkn-ath')
        const refresh = getCookie('tkn-ath-rfrsh')
        const role = getCookie('tkn-ath-role')
        if (token) {
            try {
                const getSso = await sso(token, refresh, role);
                if(getSso) {
                // navigate(`/Home`)
                }else{
                // navigateNext('/');
                }
            } catch (err) {
                // navigateNext('/');
            }
        } else {
            await getInitialGuestToken()
            .then(url=>{
                getFinalGuestToken(url.refresh_token)
                .then(data=>{
                sso(data.token,data.refresh_token,data.role)
                setRole(data.role)
                navigateNext(`/Home`)
            })
        })
        }
    }
    };
  
    const handleSubmit = (e) => {
        e.preventDefault();
        // performSso()
    };
  
    const handleShowPassword = () => {
      setShowPassword(!showPassword);
    };

    return (
    <>
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <div className="bg-white-700 w-full max-w-md shadow-md rounded-lg overflow-hidden">
                <div className="flex items-center justify-center mb-8 mt-8">
                    <img src={logoFull} alt="Logo" className="h-12" />
                </div>
                <div className="px-6 py-8">
                <h2 className="text-2xl font-bold mb-2">Sign in to your account</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4 relative">
                        <label htmlFor="email" className="block text-gray-700 font-bold mb-2">
                            Email
                        </label>
                        <div className={`flex items-center border ${errors.email ? 'border-red-500' : 'border-gray-400' } p-2 rounded-md focus-within:border-indigo-500`}>
                            <input
                            type="email"
                            id="email"
                            className="w-full focus:outline-none"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled
                            />
                             <FaEnvelope className="text-gray-500 mr-2" />
                        </div>
                        {errors.email && (
                            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                        )}
                    </div>
                    <div className="mb-6 relative">
                    <label htmlFor="password" className="block text-gray-700 font-bold mb-2">
                        Password
                    </label>
                        <div className={`flex items-center border ${errors.password ? 'border-red-500' : 'border-gray-400' } p-2 rounded-md focus-within:border-indigo-500`}>
                            <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            className="w-full focus:outline-none"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled
                            />
                            {showPassword ? (
                            <FaEyeSlash
                                className="text-gray-500 cursor-pointer ml-2"
                                onClick={handleShowPassword}
                            />
                            ) : (
                            <FaEye className="text-gray-500 cursor-pointer ml-2" onClick={handleShowPassword} />
                            )}
                        </div>
                        {errors.password && (
                            <p className="text-red-500 text-sm mt-1">{errors.password}</p>
                        )}
                    </div>
                    {location?.state?.errors && (
                            <p className="text-red-500 text-sm mt-1">{location?.state?.errors}</p>
                    )}
                    <div className="mb-6">
                    <button
                        type="submit"
                        className="w-full bg-blue-500 hover:bg-blue-700 text-white-700 font-bold py-2 px-4 rounded-md focus:outline-none focus:shadow-outline-blue"
                        // disabled={true}
                        onClick={(e) => handleSubmit(e)}
                    >
                        Sign In
                    </button>

                    </div>
                    <div className="flex items-center justify-center">
                        <span className="text-gray-500">Or</span>
                        <a href={state?.token?.external_sources?.url}>
                            <button
                                type="button"
                                className="flex items-center ml-2 bg-white border border-gray-400 hover:bg-gray-100 rounded-md focus:outline-none focus:shadow-outline-gray"
                                // onClick={handleGoogleLoginClick}
                            >
                                <FaGoogle className="text-blue-500 mr-2" />
                                <span className="text-gray-700 font-bold">Sign in with Google</span>
                            </button>
                        </a>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </>
    )
}

export default Login